"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPoolStatsPaginatedListSchema = exports.UserPoolStatsSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.UserPoolStatsSchema = zod_1.z.object({
    poolID: zod_1.z.string(),
    deposited: core_contracts_ifaces_1.TokenAmountSchema,
    depositedReserves: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
    rewards: zod_1.z.object({
        pending: zod_1.z.object({
            total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
            tokens: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
        }),
        claimed: zod_1.z.object({
            total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
            tokens: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
        }),
        earned: zod_1.z.object({
            total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
            tokens: zod_1.z.array(core_contracts_ifaces_1.TokenAmountSchema),
        }),
    }),
});
exports.UserPoolStatsPaginatedListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.UserPoolStatsSchema),
    metadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
